// src/layouts/HorizontalLayout.jsx

import React, { Suspense } from 'react';
import {
    Box,
    Container,
    CircularProgress,
    useTheme,
} from '@mui/material';

// Lazy load main sections
const Navbar = React.lazy(() => import('../components/Navbar'));
const Footer = React.lazy(() => import('../components/Footer'));

const loading = (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
        }}
    >
        {/* Header placeholder */}
        <Box component="header" sx={{ height: '64px' }} />
        {/* Content placeholder */}
        <Box component="main" sx={{ flex: 1 }} />
    </Box>
);

const NAVBAR_HEIGHT = 64;

const HorizontalLayout = ({ children }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                width: '100%',
                overflowX: 'hidden', // Prevent horizontal scroll
            }}
        >
            {/* Fixed Navbar (horizontal) */}
            <Box
                sx={{
                    position: 'fixed',
                    width: '100%',
                    zIndex: 1200,
                    height: `${NAVBAR_HEIGHT}px`,
                    boxShadow: theme => theme.shadows[2],
                    backgroundColor: theme => theme.palette.background.paper,
                }}
            >
                <Suspense fallback={loading}>
                    <Navbar />
                </Suspense>
            </Box>

            {/* Main content, scrollable below navbar */}
            <Box
                component="main"
                sx={{
                    flex: 1,
                    mt: `${NAVBAR_HEIGHT}px`, // margin-top to offset fixed navbar
                    height: `calc(100vh - ${NAVBAR_HEIGHT}px)` ,
                    overflowY: 'auto', // Only vertical scroll
                    overflowX: 'hidden', // Prevent horizontal scroll
                    width: '100%',
                    position: 'relative',
                    backgroundColor: theme => theme.palette.background.default,
                }}
            >
                <Container maxWidth={false} disableGutters>
                    <Suspense
                        fallback={
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                <CircularProgress />
                            </Box>
                        }>
                        {children}
                    </Suspense>
                </Container>
            </Box>

        </Box>
    );
};

export default HorizontalLayout;
